export default __webpack_public_path__ + "static/media/free-android.5a01156c.png";